import { ConnectionTypeModel } from "./ConnectionType.model";
import { ConnectionTypeDocumentFormatModel } from "./ConnectionTypeDocumentFormat.model";
import { CountryModel } from "./Country.model";

export class ConnectionTypeDocumentModel {
    Id : number;
    Name : string;
    IdConnectionType : number;
    IdCountry : string;
    IsActive : boolean;   
    CreatedBy : string;
    CreatedDate : Date;
    ModifiedBy : string;
    ModifiedDate : Date;

    NameDocument: string;
    Format : string;
    Terms :string;  
    Language :string;
    Extension :string;
    FormatPath: string;
    IdLanguage :number;
    IdAgencyDocument: number;
    Complete: boolean;
    Rejected: boolean;
    Edit: boolean;
    Review: boolean;
    IdRequiredDocument:number;

    IdConnectionTypeNavigation : ConnectionTypeModel;
    IdCountryNavigation : CountryModel;

    ConnectionTypeDocumentFormat : ConnectionTypeDocumentFormatModel[];
 
    FileName : string;
    FileUrl : string;
    Flow : string;
}
